import React from 'react';
import './PhotoModal.css';

const PhotoModal = ({ photo, onClose }) => {
  const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'http://localhost:5001';
  const fullUrl = photo.url.startsWith('http') || photo.url.startsWith('data:') ? photo.url : `${baseUrl}${photo.url}`;

  const handleDownload = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(fullUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = photo.filename || 'gallery-image.jpg';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
      alert('Failed to download image.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <img src={fullUrl} alt={photo.caption || 'Gallery photo'} className="modal-image" />
        {photo.caption && (
          <div className="modal-caption">{photo.caption}</div>
        )}
        <div className="modal-actions">
          <button onClick={handleDownload} className="modal-btn download-btn">
            Download
          </button>
          {/* Delete button removed from public view */}
        </div>
      </div>
    </div>
  );
};

export default PhotoModal;